import * as signin from '../signin'
declare var pageData: signin.PageData
jQuery(() => { signin.main(pageData) })
